<template>
  <div class="blogtable">
    <el-dialog
      :visible.sync="dialogVisible"
      :width="dialog === true ? '80%' : '50%'"
      :before-close="handleClose"
      center
    >
      <template slot="title">
        <h4 class="fsize16 text-white font-semibold text-left">Bulk Edit</h4>
      </template>
      <div>
        <div class="grid grid-cols-1 gap-2">
          <div class="flex justify-end items-center cursor-pointer">
            <div
              class="text-primary rounded-lg flex items-center gap-1"
              @click="dialog = !dialog"
            >
              <p class="fsize14 underline" v-if="dialog === false">
                Show Selected Blogs
              </p>
              <p class="fsize14 underline" v-else>Hide Selected Blogs</p>
              <feather-icon icon="ArrowRightIcon" svgClasses="w-4 h-4" />
            </div>
          </div>
        </div>
        <div class="flex w-full gap-3">
          <div :class="dialog === true ? 'w-7/12 mr-2' : 'w-full'">
            <div class="mt-3 editblog">
              <div class="">
                <div>
                  <label class="" for="date">Tags:</label>
                </div>
                <div class="grid grid-cols-2 items-center gap-4">
                  <b-form-select v-model="blogTag0" class="mb-3" required>
                    <b-form-select-option :value="null" disabled
                      >Select Themes
                    </b-form-select-option>
                    <b-form-select-option
                      v-for="filtertag1 in filter1"
                      :value="filtertag1._id"
                      :key="filtertag1._id"
                      >{{ filtertag1.name }}</b-form-select-option
                    >
                  </b-form-select>
                  <span v-if="showError && !tags" class="text-danger">
                    Please select a Theme
                  </span>
                  <b-form-select
                    v-model="blogTag1"
                    class="mb-3"
                    placeholder="Select"
                  >
                    <b-form-select-option :value="null" disabled
                      >Select Types
                    </b-form-select-option>
                    <b-form-select-option
                      v-for="filtertag2 in filter2"
                      :value="filtertag2._id"
                      :key="filtertag2._id"
                      >{{ filtertag2.name }}</b-form-select-option
                    >
                  </b-form-select>
                  <span v-if="showError && !type" class="text-danger">
                    Please select a Type
                  </span>
                  <multiselect
                    class="mb-3"
                    v-model="selectedUsers"
                    :options="filter3"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="From Whom"
                    track-by="_id"
                    label="name"
                    :preselect-first="false"
                  >
                  </multiselect>
                  <b-form-select v-model="selectedAuthor" class="mb-3">
                    <b-form-select-option :value="null"
                      >{{ author.length !== 0 ? "Select Author" : "No Author" }}
                    </b-form-select-option>
                    <b-form-select-option
                      v-for="author in filter4"
                      :value="author._id"
                      :key="author._id"
                      >{{ author.name }}</b-form-select-option
                    >
                  </b-form-select>
                  <b-form-select v-model="selectedDoctor" class="mb-3">
                    <b-form-select-option :value="null"
                      >{{
                        doctor.length !== 0
                          ? "Medically reviewed by"
                          : "No Doctor"
                      }}
                    </b-form-select-option>
                    <b-form-select-option
                      v-for="doctor in filter5"
                      :value="doctor._id"
                      :key="doctor._id"
                      >{{ doctor.name }}</b-form-select-option
                    >
                  </b-form-select>
                  <div class="">
                    <b-form-radio-group
                      v-model="isActive"
                      :options="isActiveOptions"
                      value-field="item"
                      text-field="name"
                    ></b-form-radio-group>
                  </div>
                </div>
              </div>
            </div>
            <div class="grid items-center gap-4 mt-3 editblog">
              <div class="">
                <b-form-checkbox id="checkbox-2" v-model="onlyRegistered">
                  <p>
                    <strong>
                      <p class="col-blk">
                        Select this option to limit access to the blog.
                      </p></strong
                    >
                  </p>
                </b-form-checkbox>
              </div>
              <div class="">
                <label for="membership">Membership:</label>
                <multiselect
                  name="membership"
                  v-model="selectedMembership"
                  :options="membershipFilter"
                  :multiple="false"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :preserve-search="true"
                  placeholder="Select Memberships"
                  track-by="name"
                  label="name"
                  :preselect-first="false"
                  :disabled="!onlyRegistered ? true : false"
                >
                </multiselect>
              </div>
            </div>
          </div>
          <div class="w-5/12 mt-10" v-if="dialog === true">
            <el-table
              :data="multipleBlog"
              ref="myTable"
              max-height="400"
              style="width: 100%"
              class="rounded-lg"
              border
            >
              <el-table-column
                prop="title"
                min-width="290px"
                label="Title"
                v-slot="{ row }"
              >
                {{ row.title }}
              </el-table-column>
              <el-table-column label="Action" min-width="50px" v-slot="{ row }">
                <feather-icon
                  icon="Trash2Icon"
                  svgClasses="w-5"
                  @click="handleRemoveSelection(row)"
                ></feather-icon>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="mt-5 flex justify-center">
          <base-button
            type="primary"
            outline
            class="px-4 my-2"
            @click="onSubmit"
            >Submit</base-button
          >
        </div>
      </div>
    </el-dialog>
    <div v-if="isEdit == true">
      <editComp @editchange="editchange" />
    </div>
    <div v-if="isEdit == false">
      <div class="flex justify-between items-center">
        <div>
          <h2 class="text-2xl font-semibold">List of Blogs</h2>

          <small class="text-muted">Manage all your blogs here. </small>
        </div>
        <div class="flex items-center gap-2">
          <b-form-select v-model="typeFilter" class="mx-1 custom-select1">
            <b-form-select-option :value="1">All Plans</b-form-select-option>
            <b-form-select-option
              v-for="(i, index) in get_all_membership"
              :value="i._id"
              :key="index"
              >{{ i.name }}</b-form-select-option
            >
          </b-form-select>
          <base-button
            outline
            class="px-4 py-2"
            type="primary"
            @click="dialogVisible = true"
          >
            Bulk Edit
          </base-button>
          <base-button
            outline
            class="px-4 py-2"
            type="primary"
            @click="handleAdd"
          >
            <span class="btn-inner--text flex justify-between items-center"
              ><feather-icon
                icon="PlusIcon"
                svgClasses="w-4 h-4"
                class="cust-HW"
              ></feather-icon
              >Create Content</span
            >
          </base-button>
        </div>
      </div>
      <b-input-group class="mt-4">
        <b-form-input
          class="border-none shadow-lg"
          type="text"
          placeholder="Enter Search...."
          v-model="search"
        ></b-form-input>

        <b-input-group-append>
          <b-button
            variant="white"
            class="flex items-center shadow-lg"
            aria-label="search"
          >
            <feather-icon
              class="cursor-pointer mr-2"
              icon="SearchIcon"
              svgClasses="w-4 h-4"
            ></feather-icon>
          </b-button>
        </b-input-group-append>
      </b-input-group>

      <b-card no-body class="mt-6" v-if="categorywisepages.data.length">
        <el-table
          class="table-responsive table-flush"
          header-row-class-name="thead-light table-th-color "
          :data="categorywisepages.data"
          border
          :row-key="getRowKey"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55"
            :reserve-selection="true"
          >
          </el-table-column>
          <el-table-column
            width="65px"
            prop="id"
            type="index"
            label="Sr No."
            :index="getIndex"
          ></el-table-column>
          <el-table-column label="Title" prop="title" sortable class-name="">
            <template v-slot="{ row }">
              <p class="font-semibold text-left name mb-0 text-sm">
                {{ row.title }}
              </p>
            </template>
          </el-table-column>
          <el-table-column label="Date" prop="title" sortable>
            <template v-slot="{ row }">
              <p class="font-semibold text-left name mb-0 text-sm">
                <!-- {{ row.date }} -->
                {{
                  new Date(row.date).toLocaleDateString("en-IN", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })
                }}
              </p>
            </template>
          </el-table-column>

          <el-table-column label="Created By" prop="createdby" sortable>
            <template v-slot="{ row }">
              <p class="font-semibold text-left name mb-0 text-sm">
                {{
                  row.createdBy._user
                    ? row.createdBy._user.firstname +
                      " " +
                      row.createdBy._user.lastname
                    : " - "
                }}
              </p>
            </template>
          </el-table-column>

          <el-table-column label="Edited By" prop="editedby" sortable>
            <template v-slot="{ row }">
              <p
                class="font-semibold text-left name mb-0 text-sm"
                v-if="row.editedBy && row.editedBy.length > 0"
              >
                <!-- {{ row.date }} -->
                {{
                  row.editedBy.at(-1)._user
                    ? row.editedBy.at(-1)._user.firstname +
                        " " +
                        row.editedBy.at(-1)._user.lastname || " "
                    : "-"
                }}
              </p>
              <p v-else>-</p>
            </template>
          </el-table-column>

          <!-- <el-table-column label="Edited On" prop="editedOn" sortable>
            <template v-slot="{ row }">
              <p class="font-semibold text-left name mb-0 text-sm">
                {{
                  row.updatedAt
                    ? new Date(row.updatedAt).toLocaleDateString("en-IN", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })
                    : "-"
                }}
              </p>
            </template>
          </el-table-column> -->
          <el-table-column label="Created On" prop="createdOn" sortable>
            <template v-slot="{ row }">
              <p class="font-semibold text-left name mb-0 text-sm">
                {{
                  row.createdAt
                    ? new Date(row.createdAt).toLocaleDateString("en-IN", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })
                    : "-"
                }}
              </p>
            </template>
          </el-table-column>

          <el-table-column label="Status" prop="isActive" sortable>
            <template v-slot="{ row }">
              <p class="font-semibold text-left name mb-0 text-sm">
                {{ row.isActive ? "Active" : "In-Active" }}
              </p>
            </template>
          </el-table-column>

          <el-table-column
            label="Actions"
            min-width="40px"
            class-name="text-center"
          >
            <template slot-scope="scope">
              <div class="flex justify-center items-center">
                <feather-icon
                  icon="EditIcon"
                  svgClasses="w-6 text-blue-500 cursor-pointer"
                  class="mr-2"
                  @click="handleEdit(scope)"
                ></feather-icon>
                <feather-icon
                  icon="Trash2Icon"
                  svgClasses="w-6 text-red-600 cursor-pointer"
                  @click="handleDelete(scope)"
                ></feather-icon>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <b-card-footer class="py-4 d-flex justify-content-end">
          <!-- <base-pagination
          v-model="currentPage"
          :total="total_row"
          :per-page="perPage"
          :currentPage="currentPage"
          @change="handlePageChange"
        ></base-pagination> -->
          <b-pagination
            v-model="currentPage"
            :total-rows="total_row"
            :per-page="perPage"
            @change="handlePageChange"
            aria-controls="my-table"
          ></b-pagination>
          <!-- <b-pagination
          first-number
          last-number
          :per-page="perPage"
          :size="size"
          :value="currentPage"
          :currentPage="currentPage"
          @change="handlePageChange"
          :align="align"
          :total-rows="total_row"
        >
          <template v-slot:prev-text>
            <a class="page-link" aria-label="Previous">
              <span aria-hidden="true"
                ><i class="fa fa-angle-left" aria-hidden="true"></i
              ></span>
            </a>
          </template>
          <template v-slot:next-text>
            <a class="page-link" aria-label="Next">
              <span aria-hidden="true"
                ><i class="fa fa-angle-right" aria-hidden="true"></i
              ></span>
            </a>
          </template>
        </b-pagination> -->
        </b-card-footer>
      </b-card>
    </div>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Button,
} from "element-ui";
import _ from "lodash";
import { mapState } from "vuex";
import editComp from "../Edit.vue";
import FeatherIcon from "../../../../../../components/FeatherIcon.vue";
import { reverse } from "lodash";

export default {
  components: {
    editComp,
    FeatherIcon,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
  },

  data() {
    return {
      search: "",
      dialog: false,
      dialogVisible: false,
      currentPage: 1,
      perPage: 10,
      total_row: 1,
      offset: 10,
      startIndex: 1,
      showError: false,
      isEdit: false,
      multipleBlog: [],
      TotalSelectedBlogs: [],
      isActiveOptions: [
        { item: true, name: "Active" },
        { item: false, name: "In-Active" },
      ],
      isActive: true,
      typeFilter: 1,
      filter1: [],
      filter2: [],
      filter3: [],
      filter4: [],
      filter5: [],
      platformOptions: [],
      membershipFilter: [],
      selectedMembership: null,
      Ctags: [],
      selectedAuthor: null,
      selectedDoctor: null,
      pageData: {},
      blog_data: {},
      blogTag0: null,
      blogTag1: null,
      selectedUsers: null,
      selectedUsersId: [],
      onlyRegistered: false,
      isFeatured: false,
    };
  },
  computed: {
    ...mapState("cms", {
      categorywisepages: "categorywisepages",
      selectedBlog: "selectedBlog",
      filtertags: "filtertags",
      filters: "filters",
    }),
    ...mapState("cmsAuthor", {
      author: "author",
    }),
    ...mapState("doctor", {
      doctor: "doctor",
    }),
    ...mapState("subscribe", {
      get_all_membership: "get_all_membership",
    }),
    // displayedPages() {
    //   return this.categorywisepages.data.slice(
    //     (this.currentPage - 1) * this.perPage,
    //     this.currentPage * this.perPageList of Blogs
    //   );
    // },
    getIndex() {
      this.startIndex = this.categorywisepages.totalPages;
      return (index) => {
        return this.startIndex - index - this.currentPage * 10 + 10;
      };
    },
    totalPages() {
      return this.categorywisepages.data.length;
    },
  },
  watch: {
    search: {
      handler: _.debounce(async function (val) {
        this.dataLoad();
      }, 500),
    },
    pageData(val) {
      this.blog_data = { ...val };
      let selectedUserData =
        this.blog_data.tags && this.blog_data.tags.slice(2);
      if (selectedUserData.length > 0) {
        this.selectedUsers = this.filter3.filter((tag) =>
          selectedUserData.includes(tag._id)
        );
      }
      if (
        Array.isArray(this.blog_data.authors) ||
        (this.blog_data.authors && this.blog_data.authors.length !== 0)
      ) {
        this.selectedAuthor = this.blog_data.authors[0]._id;
      } else {
        this.selectedAuthor = null;
      }

      if (
        Array.isArray(this.blog_data.doctors) ||
        (this.blog_data.doctors && this.blog_data.doctors.length !== 0)
      ) {
        this.selectedDoctor = this.blog_data.doctors[0]._id;
      } else {
        this.selectedDoctor = null;
      }
    },

    membershipFilter() {
      if (
        this.blog_data &&
        this.blog_data.memberships &&
        this.blog_data.memberships.length > 0
      ) {
        this.selectedMembership = this.membershipFilter.filter((membership) => {
          let data = this.blog_data.memberships.find(
            (member) => member._id === membership._id
          );
          return data;
        });
      }
    },
    selectedUsers(val) {
      this.selectedUsersId = val.map((tag) => tag._id);
    },
    typeFilter(value) {
      this.getData(value);
    },
  },
  methods: {
    async getData(value) {
      if (value) {
        let data = await this.$store.dispatch("cms/GetPagesbyCategoryForBlog", {
          id: "61adf7f010718313e80bcc4b",
          limit: this.perPage,
          offset: 0,
          isActive: false,
          search: this.search,
          membership: value != 1 ? value : false,
        });
        // console.log("data123", data);
        this.total_row = data.data.totalPages;
      }
    },
    async init() {
      this.onlyRegistered = this.selectedBlog.onlyRegistered;
      this.isFeatured = this.selectedBlog.isFeatured;
      this.isActive = this.selectedBlog.isActive
        ? this.selectedBlog.isActive
        : false;
    },
    getRowKey(row) {
      return row._id;
    },
    handleSelectionChange(val) {
      this.multipleBlog = val;
      // console.log("Multiple Blogs", this.multipleBlog);
      // this.multipleBlog = [];
      // if (this.TotalSelectedBlogs.length) {
      //   const exists = _.indexOf(this.multipleBlog, val);
      //   if (exists === -1) {
      //     this.multipleBlog = _.uniqBy(
      //       _.concat(...this.TotalSelectedBlogs, ...val),
      //       "_id"
      //     );
      //   } else if (exists <= 0) {
      //     // console.log("does Exists: ", exists);
      //     this.multipleBlog = _.without(this.TotalSelectedBlogs, val);
      //   }
      // } else {
      //   this.multipleBlog = val;
      // }
      // console.log("Multiple Blogs", this.multipleBlog);
      // this.TotalSelectedBlogs = this.multipleBlog;
    },
    handleAdd() {
      this.$router.push({ name: "addblogcontent" });
    },
    handleView(slot) {
      const { row } = slot;
      this.$router.push({
        name: "blogspage",
        params: {
          id: row._id,
          // slug: this.toKebabCase(row.title),
          slug: row._id,
        },
      });
    },
    toKebabCase(string) {
      return string.toLowerCase().replace(/\s/g, "-");
    },
    toTitleCase(string) {
      return (
        string &&
        string.slice(0, 1).toUpperCase() + string.slice(1).toLowerCase()
      );
    },
    async handleDelete(data) {
      const result = await this.deleteAlert();
      if (result.isConfirmed) {
        this.deleteData(data);
      }
    },
    async handleClose() {
      this.dialogVisible = false;
    },
    deleteAlert() {
      return this.$swal({
        title: "Are you sure?",
        html: `<p class="text-center">You won't be able to revert this!</p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#830c81",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
    },
    async deleteData({ row }) {
      const payload = row._id;
      let loader = this.$loading();
      try {
        const data = await this.$store.dispatch("cms/deletePage", payload);
        loader.close();
        if (data.code === 200) {
          await this.$swal({
            text: "Deleted successfully",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });
        }
      } catch (error) {
        loader.close();
      }
    },
    async handlePageChange(value) {
      this.currentPage = value;
      if (this.multipleBlog.length) {
        this.TotalSelectedBlogs = _.uniqBy(
          _.concat(...this.TotalSelectedBlogs, ...this.multipleBlog),
          "_id"
        );
        // console.log("Total Selected Blogs : ", this.TotalSelectedBlogs);
      }
      try {
        await this.dataLoad();
        //await this.getData(this.typeFilter);
      } catch (error) {
        console.log(error);
      }
      // let payload = {
      //   offset:
      //     this.currentPage >= 1
      //       ? (this.currentPage - 1) * this.offset
      //       : this.currentPage,
      //   id: "61adf7f010718313e80bcc4b",
      //   limit: 10,
      //   updatedAt: true,
      //   isActive: false,
      // };
      // if (this.search !== "")
      //   Object.assign(payload, { search: this.search.trim() });
      // this.filteredData = await this.$store.dispatch(
      //   "cms/GetPagesbyCategoryForBlog",
      //   payload
      // );
    },
    handleRemoveSelection(blog) {
      // const result = _.find(this.TotalSelectedBlogs, blog);
      // const result = _.pull(this.TotalSelectedBlogs, blog);
      // this.TotalSelectedBlogs = result;
      // console.log("result : ", this.TotalSelectedBlogs);
      let result = [];
      for (let i = 0; i < this.multipleBlog.length; i++) {
        if (this.multipleBlog[i]._id !== blog._id) {
          result.push(this.multipleBlog[i]);
        }
      }
      this.multipleBlog = result;
      this.handleSelectionChange(this.multipleBlog);
      // console.log("Multiple Blog : ", this.multipleBlog);
    },
    async onSubmit() {
      if (this.multipleBlog.length < 1) {
        this.dialogVisible = false;
        this.$swal.fire({
          title: "Warning!",
          text: "Kindly select a blog to proceed with editing.",
          icon: "warning",
          confirmButtonColor: "#830c81",
          confirmButtonText: "Okay",
          showCancelButton: false,
        });
      } else {
        if (!this.onlyRegistered) {
          this.selectedMembership = null;
        }
        // console.log(
        //   "Tags : ",
        //   this.blogTag0,
        //    this.blogTag1,
        //    ...this.selectedUsersId
        // );
        // console.log("Doctor: ", this.selectedDoctor);
        // console.log("Author: ", this.selectedAuthor);
        // console.log("isActive  : ", this.isActive);
        // console.log("Only Registered : ", this.onlyRegistered);
        // console.log("Membership : ", this.selectedMembership._id);
        this.Ctags.push(this.blogTag0, this.blogTag1, ...this.selectedUsersId);
        let Ids = [];
        this.multipleBlog.forEach((blog) => {
          Ids.push(blog._id);
        });
        if (this.selectedMembership !== null) {
          this.onlyRegistered = true;
        } else {
          this.onlyRegistered = this.onlyRegistered;
        }
        let loader = this.$loading();
        try {
          const bulkEditData = await this.$store.dispatch("cms/bulkEdit", {
            ids: Ids,
            authors: this.selectedAuthor,
            doctors: this.selectedDoctor,
            tags: _.uniq(this.Ctags),
            isActive: this.isActive,
            memberships: this.selectedMembership._id,
            onlyRegistered: this.onlyRegistered,
          });
          if (bulkEditData.code == 200) {
            this.$swal.fire({
              text: "Blogs have been successfully edited.",
              icon: "success",
              confirmButtonText: "Okay",
              confirmButtonColor: "#830c81",
              showCancelButton: false,
            });
            loader.close();
            this.dataLoad();
            this.dialogVisible = false;
          }
        } catch (error) {
          if (error) {
            loader.close();
          }
        }
      }
    },
    async handleEdit(scope) {
      let { row } = scope;
      await this.$store.commit("cms/SET_SELECTED_BLOG", row);
      this.isEdit = true;
    },
    async dataLoad() {
      let payload = {
        offset: (this.currentPage - 1) * 10,
        id: "61adf7f010718313e80bcc4b",
        limit: 10,
        // updatedAt: true,
        isActive: false,
        search: this.search,
      };
      this.filteredData = await this.$store.dispatch(
        "cms/GetPagesbyCategoryForBlog",
        payload
      );
      this.total_row = this.categorywisepages.totalPages;
      // console.log(this.categorywisepages);
    },
    editchange() {
      this.isEdit = false;
      this.getData(this.typeFilter);
      // this.dataLoad();
    },
    async gettagsbycategory() {
      this.filter1 = this.filtertags.filter(
        (x) => x.filter._id == this.filters[0]._id
      );
      this.filter2 = this.filtertags.filter(
        (x) => x.filter._id == this.filters[1]._id
      );
      this.filter3 = this.filtertags.filter(
        (x) => x.filter._id == this.filters[2]._id
      );
      // let filteredAPIData = await this.$store.dispatch(
      //   "cms/GetPagesbyCategoryForBlog",
      //   {
      //     id: this.categoryId,
      //   }
      // );
      // this.filteredData = filteredAPIData.data;
      this.rows = Number(this.filteredData.totalPages);

      let filteredAuthorAPIData = await this.$store.dispatch(
        "cmsAuthor/getAuthor"
      );
      this.filter4 = this.author.result;
      let filteredDoctorAPIData = await this.$store.dispatch(
        "doctor/getDoctor"
      );
      this.filter5 = this.doctor.result;
      let filteredMembershipAPIData = await this.$store.dispatch(
        "subscribe/GetAllMembership"
      );
      this.membershipFilter = this.get_all_membership.filter((membership) => {
        if (
          membership.name.toLowerCase() !== "visitor" &&
          membership.name.toLowerCase() !== "registered"
        ) {
          return true;
        }
        return false;
      });
    },
  },
  mounted() {
    let loader = this.$loading();

    this.init();
    this.dataLoad();
    this.gettagsbycategory();
    let memberships = this.$store.dispatch("subscribe/GetAllMembership");
    loader.close();
  },
};
</script>

<style scoped>
.clr606266 {
  color: #606266;
}
.custom-select1 {
  width: 150px;
}
</style>
